import { render, staticRenderFns } from "./cancellationBox.vue?vue&type=template&id=f31f4e88&scoped=true&"
import script from "./cancellationBox.vue?vue&type=script&lang=js&"
export * from "./cancellationBox.vue?vue&type=script&lang=js&"
import style0 from "./cancellationBox.vue?vue&type=style&index=0&id=f31f4e88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31f4e88",
  null
  
)

export default component.exports